import { useCallback, useContext, useMemo } from "react";
import { Card } from "reactstrap";
import { usePreferenceQuery } from "../../Settings/Configuration/api/usePreferenceQuery";
import { usePreferenceMutation } from "../../Settings/Configuration/api/usePreferenceMutation";
import Content from "../../Settings/General/Notifications/Content";
import { ProfileContext } from "../context";

function NotificationSettings() {
	const { user, isSelf } = useContext(ProfileContext);
	const { userData, isLoading } = usePreferenceQuery(user?.id);

	const data = useMemo(() => ({
		notifications: userData?.find((item) => item.preferenceKey === "notifications")?.config,
	}), [userData]);

	const { mutateAsync: submit, isPending: submitting } = usePreferenceMutation("user", "notifications", user?.id);

	const onFinish = useCallback(
		async (config, onSuccess) => {
			try {
				const response = await submit(config);
				onSuccess?.(response);
			} catch (error) {
				// error toast handled by usePreferenceMutation
			}
		},
		[submit]
	);

	return (
		<Card className="h-100">
			<Content
				values={data}
				loading={isLoading}
				submitting={submitting}
				submit={onFinish}
				page="profile"
				isSelf={isSelf}
				user={user}
			/>
		</Card>
	);
};

export default NotificationSettings;
